import {
  Button,
  Card,
  Div,
  Flex,
  Image,
  LoadingSpinner,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useBydesignProduct } from 'src/hooks/useBydesignProduct'
import { State } from 'src/redux/reducers/index'

type BydesignProductItemType = {
  productId: string
}
export const BydesignProductItem: FC<BydesignProductItemType> = ({
  productId,
}) => {
  const state = useSelector((state: State) => state)
  const sponsorId =
    state.storefront.storefront?.user.genealogyId.toString() ?? '9070'
  const variables = {
    productId,
    sponsorId,
  }
  const { data, loading, error } = useBydesignProduct(variables)
  const resolveBydesignImage = (url?: string) =>
    url
      ? `https://extranet.securefreedom.com/SendOutCards/Shopping/Images/${url}`
      : ''

  const formatPrice = (price?: string) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    })
    if (price) {
      return formatter.format(parseInt(price, 10))
    }
    return undefined
  }
  const openInNewTab = (url: string) => {
    const mutableNewWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (mutableNewWindow) mutableNewWindow.opener = null
  }
  const viewDetailsUrl = `https://shop.bydesign.com/SendOutCards/#/shop/detail/${data?.getProductItem.product.productID}/from/${sponsorId}`

  const shopAllUrl = `https://shop.bydesign.com/SendOutCards/#/shop/from/${sponsorId}&categoryID=${data?.getProductItem.product.categoryID}?MarketShow=553&categoryID=${data?.getProductItem.product.categoryID}`

  if (error) {
    return <></>
  }

  return (
    <Card
      boxShadow="mediumLight"
      borderRadius="small"
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      backgroundColor="foreground"
      inset="x3"
    >
      {loading ? (
        <LoadingSpinner size="large" />
      ) : (
        <Div width="100%" height="100%">
          <Image
            // backgroundSize="contain"
            image={{
              url: resolveBydesignImage(
                data?.getProductItem.product.smallImageURL,
              ),
            }}
            width="100%"
            height={'200px'}
            isActive={true}
          />
          <Spacer space="x3" />
          <Text
            type="largeBody"
            content={data?.getProductItem.product.displayName}
            color="primaryHeading"
          />
          <Text
            weight="semiBold"
            type="body"
            content={formatPrice(data?.getProductItem.product.price)}
          />
          <Flex
            position="absolute"
            bottom="24px"
            flexDirection="row"
            justifyContent="space-between"
            width="calc(100% - 48px)"
          >
            <Button
              title="Shop All"
              size="small"
              outlined={true}
              type="shadow"
              onClick={() => openInNewTab(shopAllUrl)}
            />
            <Button
              title="View Details"
              size="small"
              onClick={() => openInNewTab(viewDetailsUrl)}
            />
          </Flex>
        </Div>
      )}
    </Card>
  )
}
